import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Row, Col, Spin, message, Modal } from "antd";
// import Icon from '@ant-design/icons';
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import liracrypt from "./Liracrypt/liracrypt";
import noImg from '../assets/static/noImg.jpeg';

import ApiErrorComp from "./ApiErrorComp/ApiErrorComp";
import { createRoute } from "../utils/CustomFunc";
import ZenModal from "./ZenModal";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import MultiText from "./MultiText";
// import { useDispatch, useSelector } from "react-redux";
// import { Drawer, Layout, Col, Row } from "antd";

const style = { padding: "8px 0", textAlign: "center" };

const colorList = [
    "#ff9ff3",
    "#feca57",
    "#ff6b6b",
    "#f368e0",
    "#ff9f43",
    "#ee5253",
    "#00d2d3",
    "#54a0ff",
    "#5f27cd",
];

const ZenMenu = ({ recordData, menu = [], refreshData = () => { }, togglePrevModal }) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [loginError, setLoginError] = useState(false);
    const urlCode = useSelector(state => state.urlCode);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
        setModal({ show, data, type, loading });
    }


    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (rd) => {
        let record = { ...recordData, ...rd };
        if (record.zenPop) {
            let zenPopDataIndex = { ...record.zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'refreshData') {
                return refreshData({ ...zenPopDataIndex?.params })
            }
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }



    const fetchHotlineData = () => {
        setLoading(true);
        liracrypt
            .get("/textapi", { dn: 'HotLine2' })
            .then(({ data }) => {
                const fetchdata = data.data ? data.data : [];
                setData(fetchdata);
                setLoading(false);
            })
            .catch(function (error) {
                // message.error('ERROR: Unable to save!', 4);
                console.log("Error****:");
                setLoading(false);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };

    useEffect(() => {
        setData(menu);
    }, []);
    return !loading && data ? (
        <div>
            <ZenModal smodalCallback={() => refreshData()} modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
            {
                data.length &&
                <MultiText data={data} recordData={recordData} />
            }
        </div>
    ) : (
        <div className="Loading">
            <Spin indicator={antIcon} />
        </div>
    );
};

export default ZenMenu;
